import {
  LayoutDashboard,
  Activity,
  FileBadge,
  School,
  UserCog,
  Shield,
  Briefcase,
  FileSpreadsheet,
  Anchor,
  Settings2,
  ClipboardList,
  Ship,
} from "lucide-react";

export const MenuItems = [
  {
    title: 'Dashboard',
    icon: LayoutDashboard,
    url: '/dashboard',
    module: 'dashboard',
    action: 'view',
    allowedRoles: ['SuperAdmin', 'Admin', 'Institute', 'Cadet'],
  },
  {
    title: 'System Users',
    icon: UserCog,
    url: '/users',
    module: 'users',
    action: 'view',
    allowedRoles: ['SuperAdmin'],
  },
  // {
  //   title: "Institutes",
  //   icon: School,
  //   module: "institutes",
  //   action: "view",
  //   allowedRoles: ["SuperAdmin"],
  //   subItems: [
  //     {
  //       title: "All Institutes",
  //       icon: School,
  //       url: "/institutes",
  //       module: "institutes",
  //       action: "view",
  //       exact: true,
  //     },
  //     {
  //       title: "Submissions",
  //       icon: FileText,
  //       // url: '/institutes/submissions',
  //       module: "institutes",
  //       action: "view",
  //     },
  //   ],
  // },
  {
    title: 'All Institutes',
    icon: School,
    url: '/institutes',
    module: 'institutes',
    action: 'view',
    allowedRoles: ['Institute'],
  },
  // {
  //   title: 'Cadet Management',
  //   icon: Users,
  //   module: 'cadets',
  //   action: 'view',
  //   allowedRoles: ['SuperAdmin', 'Institute'],
  //   subItems: [
  //     {
  //       title: 'Engine Cadets',
  //       icon: Users,
  //       url: '/cadets/engine',
  //       module: 'cadets',
  //       action: 'view',
  //     },
  //     {
  //       title: 'Deck Cadets',
  //       icon: Users,
  //       url: '/cadets/deck',
  //       module: 'cadets',
  //       action: 'view',
  //     },
  //     {
  //       title: 'Shortlisted Cadets',
  //       icon: ListChecks,
  //       url: '/cadets/shortlist',
  //       module: 'cadets',
  //       action: 'view',
  //     },
  //   ],
  // },
  {
    title: 'Recruitment Drives',
    icon: Briefcase,
    url: '/drives',
    module: 'recruitment_drives',
    action: 'view',
    allowedRoles: ['SuperAdmin', 'Institute'],
  },
  {
    title: 'Submit Excel',
    icon: FileSpreadsheet,
    url: '/institute/submit-excel',
    module: 'submit-excel',
    action: 'view',
    allowedRoles: ['Institute'],
  },
  {
    title: 'CTV Allocation',
    icon: Anchor,
    url: '/allocations',
    module: 'allocations',
    action: 'view',
    allowedRoles: ['SuperAdmin', 'Admin'],
  },
  {
    title: 'My Follow-ups',
    icon: ClipboardList,
    url: '/my-follow-ups',
    internalOnly: true,
  },
  {
    title: 'Onboarding',
    icon: ClipboardList,
    url: '/onboarding',
    module: 'onboarding',
    action: 'view',
    allowedRoles: ['SuperAdmin', 'Admin'],
  },
  {
    title: 'Medical Center',
    icon: FileBadge,
    module: 'medical-centers',
    action: 'view',
    allowedRoles: ['SuperAdmin', 'Institute'],
    subItems: [
      {
        title: 'All Medical Centers',
        url: '/medical-centers',
        module: 'medical-centers',
        action: 'view',
      },
      {
        title: 'Medical Reports',
        url: '/medical-reports',
        module: 'medical-centers',
        action: 'view',
      },
    ],
  },
  {
    title: 'Assessment Master',
    icon: Settings2,
    url: '/allocation-masters',
    module: 'allocation-masters',
    action: 'view',
    allowedRoles: ['SuperAdmin', 'Admin'],
  },
  {
    title: 'Vessel Management',
    icon: Ship,
    module: 'vessel-master',
    action: 'view',
    allowedRoles: ['SuperAdmin', 'Admin'],
    subItems: [
      {
        title: 'Vessel Type Master',
        icon: Anchor,
        url: '/vessel-types',
        module: 'vessel-master',
        action: 'view',
      },
      {
        title: 'Vessel Master',
        icon: Ship,
        url: '/vessels',
        module: 'vessel-master',
        action: 'view',
      },
    ],
  },
  // {
  //   title: 'Screening',
  //   icon: ClipboardCheck,
  //   url: '/screening',
  //   module: 'screening',
  //   action: 'view',
  //   allowedRoles: ['SuperAdmin', 'Institute'],
  // },
  // {
  //   title: 'Tests & Interviews',
  //   icon: ListChecks,
  //   url: '/tests',
  //   module: 'tests',
  //   action: 'view',
  //   allowedRoles: ['SuperAdmin', 'Institute'],
  // },
  // {
  //   title: 'Medical & Docs',
  //   icon: FileBadge,
  //   url: '/medical',
  //   module: 'medical',
  //   action: 'view',
  //   allowedRoles: ['SuperAdmin', 'Institute'],
  // },
  {
    title: 'Role Permissions',
    icon: Shield,
    url: '/role-permissions',
    module: 'role-permissions',
    action: 'manage',
    allowedRoles: ['SuperAdmin'],
  },
  {
    title: 'Activity Logs',
    icon: Activity,
    url: '/activity-logs',
    module: 'activity-logs',
    action: 'view',
    allowedRoles: ['SuperAdmin'],
  },
];
